import {ChangeDetectionStrategy, Component, computed, Input, signal} from '@angular/core';
import {NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {
  AIRecommendationsGenerationProgress,
  GENERATION_STATUSES
} from 'src/app/shared/models/generation-status.interface';

@Component({
  selector: 'app-recommendations-generation-status',
  templateUrl: 'recommendations-generation-status.component.html',
  styleUrls: ['recommendations-generation-status.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatProgressSpinnerModule, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecommendationsGenerationStatusComponent {
  @Input() set recommendationsGenerationProgress(progress: AIRecommendationsGenerationProgress) {
    this.status.set(progress.status);
    this.text.set(progress.text);
  }

  private status = signal<GENERATION_STATUSES | null>(null);
  public text = signal<string>('');

  public isFailed = computed(() => this.status() === GENERATION_STATUSES.FAILED);
  public isInProgress = computed(() => this.status() === GENERATION_STATUSES.IN_PROGRESS);
}
